<template>
    <vx-card title="Добавить площадку" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Тип площадки </label>
                    <v-select
                        :options="dicts.platformTypes"
                        label="description"
                        placeholder="Выберите тип"
                        class="w-full"
                        v-bind:class="{ 'v-select-error': !!errors.platformTypeId }"
                        v-model="item.platformTypeId"
                        :reduce="a => a.id"
                        :clearable="false"
                    ></v-select>
                    <div
                        v-if="errors.platformTypeId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.platformTypeId }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.appName"
                        :danger="!!errors.appName"
                        :danger-text="errors.appName"
                        autocomplete="off"
                        label="Наименование"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.siteId"
                        :danger="!!errors.siteId"
                        :danger-text="errors.siteId"
                        autocomplete="off"
                        label="Id сайта"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.url"
                        :danger="!!errors.url"
                        :danger-text="errors.url"
                        autocomplete="off"
                        label="URL площадки или приложения в магазине приложений"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled"> Сохранить </vs-button>
        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'platform-create',
    data() {
        return {
            item: {},
            dicts: {
                platformTypes: []
            },
            errors: {
                platformTypeId: '',
                url: ''
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.axios
                .all([this.axios.get('platforms/dictionaries')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.platformTypes = dicts.data.platformTypes;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.item, { id: this.id });

            this.$axios({
                method: 'POST',
                url: 'platforms',
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно добавлено",
                        text: "Площадка успешно добавлена",
                        color: "success",
                    });
                    this.$router.push('/ord/platforms');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: error,
                            color: "danger",
                            time: 8000
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при добавлении площадки!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/ord/platforms');
        },
    },
    mounted() {
        this.loadDicts();
    }
};
</script>

<style scoped>
</style>